const config_api = require("../../../config/config").config_api;
const utils = require("../../../utils");
const axios = require('axios');

function clerkDeposit(data,callback) {
    axios({
        url: config_api.commerce+"/deposit",
        method: 'POST',
        headers: {
            "Content-type": "application/json",
            "Authorization": 'Bearer ' + utils.getAuthToken()
        },
        data: data
    })
    .then(result => {
        return callback(false, result.data)
    })
    .catch(error => {
        if (error.response) {
            return callback(error.response);
        } else if (error.request) {
            return callback("Đường truyền bị gián đoạn");
        } else {
            return callback(error.message);
        }
    });
}


module.exports = {
    clerkDeposit: clerkDeposit,

};